<template>
    <div class="ordered-list">
        <ol class="list">
            <li
                v-for="(item, index) in data.items"
                :key="index"
                class="item"
            >
                <p class="p">
                    <b class="bold">{{ item.title }}</b>
                    {{ item.description }}
                </p>
            </li>
        </ol>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Color, ComponentOrderedListFragment } from '@/graphql/api'
import { cmsColorToButtonColor } from '@/components/cms'
import type { Colors } from '@/components/ui'
import { getColorForBackground } from '@/components/ui/buttons'

const props = defineProps<{
    data: ComponentOrderedListFragment
    background?: Color
}>()

const thColor = computed((): Colors | undefined => {
    if (!props.background) {
        return undefined
    }

    return getColorForBackground(cmsColorToButtonColor(props.background))
})
</script>

<style lang="scss" scoped>
.ordered-list {
    font-family: $sectra-font-stack;
    font-weight: 500;
    color: v-bind(thColor);
    margin: 0 auto 20px;
    width: 100%;
    max-width: 680px;
    line-height: 1.45rem;

    .list {
        margin: 0 0 20px;
        padding: 0 0 0 20px;
        counter-reset: list;

        .item {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 20px 0;
            border-bottom: 1px solid rgba($black, 0.1);

            &::before {
                flex-shrink: 0;
                display: block;
                border-radius: 50%;
                font-family: $parcel-font-stack;
                font-size: 1.5rem;
                width: 42px;
                height: 42px;
                line-height: 42px;
                text-align: center;
                background: $blue;
                color: $white;
                counter-increment: list;
                content: counter(list);
                margin: 0 15px 0 0;
            }

            .p {
                font-size: 0.875rem;
                line-height: 1.2em;

                .bold {
                    display: block;
                    font-weight: 400;
                    font-size: 1.2rem;
                    margin: 0 0 5px;
                }
            }
        }
    }
}
</style>
